module.exports = __webpack_public_path__ + "static/media/pnln-newsletter.9a83906c.png";